import {Pipe, PipeTransform} from '@angular/core';
import {DateUtilities} from '../utilities/date-utilities.model';

@Pipe({
	name: 'timeFromNow'
})
export class TimeFromNowPipe implements PipeTransform {

	transform(value: any, args?: any): string {
		return DateUtilities.getMoment(value).fromNow();
	}

}
